import { render, staticRenderFns } from "./VlLogTableHeader.vue?vue&type=template&id=2d032aa6&"
import script from "./VlLogTableHeader.vue?vue&type=script&lang=js&"
export * from "./VlLogTableHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports